export default {
  upload_common: {
    required: '為必填項目。',
    max_length_500: '必須在500字以下。',
    please_enter_a_number: '請輸入數字。',
    unexpected_error: '發生意外錯誤。',
    temporarily_saved: '已暫存。',
    unanswered_items: '有未回答的項目。',
    answer_questionnaire_select: '請選擇要回答的問卷',
    entry: '請填寫',
    target_select: '請選擇。',
    value_unit: '值',
    unit: '單位',
    attach_documents: '附加資料',
    textarea_placeholder: '需要描述，或是還有要補充的記載時，請於此記載。',
    // textarea_placeholder_with_file: '',
    temporary_storage: '暫存',
    submit: '提交',
    last_saved_temporary: '最後一筆草稿的儲存日期與時間',
    There_are_unanswered_questions: '有未回答的項目',
    submitted_text: '此調查表／問卷調查提交中。',
    submitted_at: '提交日期與時間',
    withdrawal_of_answer: '撤銷回答',
    withdrawal_accepted: '回答已回傳',
    help: '說明',
    example_of_evidence: '憑證範例',
    save_temporary_answer: '暫存調查表／問卷調查',
    saved_temporary_answer: '回答內容已暫存。',
    submit_answer: '提交調查表／問卷調查',
    confirm_submit_answer: '回答中的調查表／問卷調查是否寄出？',
    confirm_submit_shared_text: '\n回答內容將與委託調查企業共享。',
    complete_submit_answer: '調查表/問卷調查已提交。\n感謝您的協助。',
    // recommend_asuene: '',
    // not_at_all: '',
    // absolutely: '',
    // let_us_know_your_thoughts: '',
    // thank_you_for_your_cooperation: '',
    // glad_to_support: '',
    back_answer: '返回回答',
    close: '關閉',
    save_temporary_answer_and_prev: '儲存後前往上一步',
    save_temporary_answer_and_next: '儲存後前往下一步',
    prev: '前往上一步',
    next: '前往下一步',
    question_group_question_download: '下載提問',
    question_group_answer_download: '下載回答',
    question_group_download_answer_csv_title: '提問・回答(CSV)',
    question_group_download_answer_csv_description: '以CSV格式下載回答。',
    question_group_download_answer_pdf_title: '提問・回答(PDF)',
    question_group_download_answer_pdf_description: '以PDF格式下載回答。',
    question_group_download_scorecard_pdf_title: '評分卡(PDF)',
    question_group_download_scorecard_pdf_description: '以PDF格式下載評分。',
    question_group_download_esg_award_svg_title: 'ESG大獎(SVG)',
    question_group_download_esg_award_svg_description: '以SVG格式下載大獎。',
    question_group_download_esg_award_pdf_title: 'ESG大獎(PDF)',
    question_group_download_esg_award_pdf_description: '以PDF格式下載大獎。',
    request_survey_withdrawal: '委託撤銷回答',
    survey_withdrawal_description: '向委託評估企業委託撤銷回答。\n請在以下記載希望撤銷的理由後寄送。對委託評估企業顯示內容。',
    reason_withdrawal_request: '希望撤銷的理由',
    completed_withdrawal_request: '已要求撤銷回覆。\n請耐心等候系統退回。',
    send: '寄送',
    cancel: '取消',
    balloon_title_withdrawal_request: '已要求撤銷回覆。',
    no_survey: '目前沒有調查表／問卷的回覆要求。',
    failed_to_save_before_export: '下載前的暫存失敗。輸入內容不完整，請確認。',
    filter_unfilled_questions: '僅顯示未回答的題目',
    no_unfilled_questions: '無未回答的問題。',
    move_page: '離開頁面',
    confirm_move_page_message: '回答內容尚未儲存。\n如果直接離開，資料將會消失。是否要儲存後再離開？',
    confirm_without_save: '不儲存離開',
    confirm_with_save: '儲存後離開',
    error_save: '暫存請確認輸入內容。',
    // there_are_no_unanswered_questions: "",
    someone_editing_survey: '編輯中的調查表／問卷',
    unable_edit_someone_editing_survey: '由於目前有使用者正在回答該調查表／問卷，故無法編輯。',
    user_editing_survey: '正在編輯中',
    reference_question: {
      // see_previous_answers: "",
      previous_answers: '過去的回答內容',
      // overwrite_with_previous_answers: "",
      submitted_at: '（{submitted_at} 提交）',
      // related_question: "",
      click_to_expand: '點擊展開',
      click_to_omit: '點擊收起',
      // description: "",
      answer_reference_function: '自動填入回答功能',
      overwrite: '覆蓋',
      overwrite_confirm: '在回答中的調查表／問卷中，自動輸入過去回答。\n若已輸入回答，該回答將會被覆蓋。',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: '項目',
      activity_amount: '活動量',
      emission_factor: '排放係數',
      emission_amount: '排放量',
      unit_sale: '營業額基本單位',
      total: '總計',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/百萬日圓',
    },
    label: {
      required_answer: '必答',
      optional_answer: '任答',
      conditional_required_answer: '依條件作答',
      note: '備註',
      // evidence_attachments: "",
    },
    //  required_answer: '',
    //  optional_answer: '',
    //  conditional_required_answer: '',
    //  note: '',
    //  evidence_attachments: '',
    // no_available_in_pdf: ''
    // comparison_question_meta: '',
    // error_footer: '',
    // error_panel_title: '',
    // error_panel_description: '',
    // error_panel_support_text_1: '',
    // error_panel_support_label: '',
    // error_panel_support_text_2: '',
    // error_panel_resolved: '',
    // error: '',
    // error_revision_required: '',
    // alert: '',
    // alert_detected: '',
    question_group_download_answered_csv_title: '問題・回答(CSV)',
    question_group_download_answered_pdf_title: '問題・回答(PDF)',
  }
}
